import {
  Box,
  VStack,
  HStack,
  Text,
  Heading,
  Image,
  Flex,
  Icon,
} from '@chakra-ui/react'
import { CalendarIcon, TimeIcon } from '@chakra-ui/icons'
import React from 'react'

const EventBraxtonBlueWhite: React.FC = () => (
  <Box overflow='hidden' borderRadius='md'>
    <Image
      src='/braxton-blue-white-kickoff-2026.png'
      alt='Blue & White Night Kickoff at Braxton Brewing flyer'
      w='100%'
      maxH={{ base: '280px', md: '360px' }}
      objectFit='cover'
      objectPosition='top'
      mb={6}
      borderRadius='md'
    />

    <VStack spacing={5} align='stretch'>
      <Box textAlign='center'>
        <Text
          fontSize='sm'
          letterSpacing='0.2em'
          textTransform='uppercase'
          color='blue.400'
          fontWeight='bold'
          mb={1}>
          Kick Off Blue & White Night
        </Text>
        <Heading
          as='h2'
          size='lg'
          fontFamily='Cherry Swash'
          color='blue.800'
          lineHeight='1.2'>
          Raise a Pint. Shine Kindness.
        </Heading>
        <Text mt={2} fontStyle='italic' color='blue.600' fontSize='lg'>
          Good beer. Great cause.
        </Text>
      </Box>

      <Box
        bg='blue.800'
        color='white'
        py={3}
        px={4}
        borderRadius='md'
        textAlign='center'>
        <Text
          fontSize={{ base: 'sm', md: 'md' }}
          fontWeight='bold'
          letterSpacing='0.08em'
          textTransform='uppercase'>
          $1 from every pint purchased goes to Shine Like Lauren Inc.
        </Text>
      </Box>

      <Flex
        direction={{ base: 'column', sm: 'row' }}
        gap={4}
        justify='space-between'
        bg='blue.50'
        borderRadius='md'
        p={4}>
        <HStack spacing={3} align='flex-start'>
          <Icon as={CalendarIcon} color='blue.600' mt={1} boxSize={5} />
          <Box>
            <Text fontSize='xs' textTransform='uppercase' color='blue.500' fontWeight='bold'>
              Date
            </Text>
            <Text fontWeight='semibold' color='blue.900'>
              Monday, August 3, 2026
            </Text>
          </Box>
        </HStack>
        <HStack spacing={3} align='flex-start'>
          <Icon as={TimeIcon} color='blue.600' mt={1} boxSize={5} />
          <Box>
            <Text fontSize='xs' textTransform='uppercase' color='blue.500' fontWeight='bold'>
              Time
            </Text>
            <Text fontWeight='semibold' color='blue.900'>
              5:00 PM – 8:00 PM
            </Text>
          </Box>
        </HStack>
      </Flex>

      <Box>
        <Text fontSize='xs' textTransform='uppercase' color='blue.500' fontWeight='bold' mb={1}>
          Location
        </Text>
        <Text fontWeight='semibold' color='blue.900'>
          Braxton Brewing – Union
        </Text>
        <Text color='gray.600'>8901 U.S. 42, Union, KY</Text>
      </Box>

      <Text color='gray.700' lineHeight='tall'>
        Your pint helps support scholarships and community initiatives that
        spread kindness, hope, and compassion. Bring your friends. Enjoy great
        local beer. Let&apos;s raise a pint and shine kindness forward!
      </Text>

      <Text
        textAlign='center'
        fontFamily='Cherry Swash'
        color='blue.500'
        fontSize='md'
        letterSpacing='0.05em'>
        Kindness. Hope. Compassion.
      </Text>
    </VStack>
  </Box>
)

export default EventBraxtonBlueWhite
